import { useMemo } from 'react';
import { CREDIT_PORTAL_URL } from 'shared';
export function usePrequalifyLink(channel, locationId) {
    return useMemo(() => {
        const params = new URLSearchParams();
        if (channel)
            params.set('pwa_channel', channel);
        if (locationId != null)
            params.set('pwa_location_id', String(locationId));
        const query = params.toString();
        return query ? `${CREDIT_PORTAL_URL}?${query}` : CREDIT_PORTAL_URL;
    }, [channel, locationId]);
}
